import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { useFieldArray } from 'react-hook-form'

import AtomButton from '@/components/Atoms/AtomButton/AtomButton'
import { digitsMask } from '@/utils/forms/inputMasks'

import { labelWithTooltip } from '../../../RequiredLabel/labelWithTooltip'
import {
  type ConfigFieldContext,
  ConfigTextField,
} from '../../ConfigFields/ConfigFields'
import { CONFIG_TOOLTIPS } from '../../lib/configModalTexts'
import cn from './TextQuantityMappingField.module.scss'

type TextQuantityMappingFieldProps = {
  context: ConfigFieldContext
}

function TextQuantityMappingField({ context }: TextQuantityMappingFieldProps) {
  const { fields, append, remove } = useFieldArray({
    control: context.control,
    name: 'textQuantityMapping',
  })
  const rowErrors = context.errors.textQuantityMapping

  return (
    <div className={cn.mapping}>
      <div className={cn.header}>
        <span className={cn.title}>
          {labelWithTooltip(
            'Текстовые остатки в числа',
            CONFIG_TOOLTIPS.textQuantityMapping
          )}
        </span>
        <AtomButton
          variant="secondary"
          icon={<PlusOutlined />}
          onClick={() => append({ key: '', value: '' })}
        >
          Добавить
        </AtomButton>
      </div>
      {fields.map((field, index) => (
        <div key={field.id} className={cn.row}>
          <ConfigTextField
            context={context}
            name={`textQuantityMapping.${index}.key`}
            title="Текст в файле"
            placeholder="В наличии"
            required
            error={rowErrors?.[index]?.key?.message}
          />
          <ConfigTextField
            context={context}
            name={`textQuantityMapping.${index}.value`}
            title="Число"
            placeholder="10"
            required
            mask={digitsMask}
            error={rowErrors?.[index]?.value?.message}
          />
          <AtomButton
            variant="secondary"
            icon={<DeleteOutlined />}
            className={cn.remove}
            aria-label="Удалить строку"
            onClick={() => remove(index)}
          />
        </div>
      ))}
    </div>
  )
}

export default TextQuantityMappingField
